import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, onAddToCart, onQuickView, isLoading = false }) => {
  const SkeletonCard = () => (
    <div className="bg-surface rounded-card shadow-card animate-pulse">
      <div className="h-48 bg-border rounded-t-card"></div>
      <div className="p-4 space-y-3">
        <div className="h-4 bg-border rounded w-3/4"></div>
        <div className="h-3 bg-border rounded w-1/2"></div>
        <div className="flex items-center space-x-2">
          <div className="flex space-x-1">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-3 h-3 bg-border rounded-full"></div>
            ))}
          </div>
          <div className="h-3 bg-border rounded w-8"></div>
        </div>
        <div className="flex items-center justify-between">
          <div className="h-5 bg-border rounded w-16"></div>
          <div className="h-3 bg-border rounded w-12"></div>
        </div>
        <div className="h-9 bg-border rounded"></div>
      </div>
    </div>
  );

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4 lg:gap-6">
        {[...Array(12)].map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-24 h-24 bg-border rounded-full flex items-center justify-center mb-4">
          <svg className="w-12 h-12 text-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <h3 className="font-heading font-heading-semibold text-lg text-text-primary mb-2">
          No products found
        </h3>
        <p className="text-text-secondary max-w-md">
          We couldn't find any products matching your criteria. Try adjusting your filters or search terms.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4 lg:gap-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onAddToCart={onAddToCart}
          onQuickView={onQuickView}
        />
      ))}
    </div>
  );
};

export default ProductGrid;